import { render, staticRenderFns } from "./MainVue.vue?vue&type=template&id=40d9f15b&scoped=true"
import script from "./MainVue.vue?vue&type=script&lang=js"
export * from "./MainVue.vue?vue&type=script&lang=js"
import style0 from "./MainVue.vue?vue&type=style&index=0&id=40d9f15b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d9f15b",
  null
  
)

export default component.exports